import { z } from 'zod';
/**
 * Call Transfer v1 Configuration Validator
 * Validates transfer configuration including destination and transfer settings
 */
export const Call_Transfer_1_ConfigValidator = z.object({
    destinationType: z.enum(['phoneNumber', 'sipUri']),
    phoneNumber: z.string().optional(),
    sipUri: z.string().optional(),
    extension: z.string().optional(),
    transferMode: z.enum([
        'blind-transfer',
        'warm-transfer-say-message',
        'warm-transfer-say-summary',
        'warm-transfer-wait-for-operator-to-speak-first-and-then-say-message',
        'warm-transfer-wait-for-operator-to-speak-first-and-then-say-summary',
        'warm-transfer-with-twiml'
    ], { message: 'Select a transfer mode' }),
    message: z.string().optional(),
    callerId: z.boolean().optional(),
    sipVerb: z.enum(['refer', 'bye', 'dial']).nullable().optional(),
    addSipHeadersToUrl: z.boolean().optional(),
    sipHeaders: z.record(z.string(), z.string()).optional()
});
//# sourceMappingURL=call-transfer-1.js.map